import { BoldCheckedIcon } from '@src/svg';
import { FC, MouseEventHandler, ReactNode } from 'react';

type SsoRowButtonProps = {
  provider: string;
  icon: ReactNode;
  activated: boolean;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const SsoRowButton: FC<SsoRowButtonProps> = ({
  provider,
  icon,
  activated,
  disabled,
  onClick,
}) => (
  <button
    className={`pf-sso${activated ? ' on' : ''}`}
    type="button"
    onClick={onClick}
    disabled={disabled || activated}
    aria-label={`Sign in with ${provider}`}
  >
    <span className="pf-ico">{icon}</span>
    <span className="pf-st">
      <b>Sign in with {provider}</b>
      <small>{activated ? 'Linked to your account' : 'Not linked'}</small>
    </span>
    {activated ? (
      <span className="pf-ok">
        <BoldCheckedIcon width={14} height={14} />
        Linked
      </span>
    ) : (
      <span className="pf-link">Link</span>
    )}
  </button>
);
